/* eslint-disable @typescript-eslint/restrict-template-expressions */
import type { Partner } from '@oneaudi/audi-partner-utils';
import { Buffer } from 'buffer';

export const createDirectionsLink = ({ name, address, dealerId }: Partner): string => {
  const destination = encodeURIComponent(
    `${name},${address},${dealerId.substring(0, 2)}`.replace(/&amp;/g, '&'),
  ).replace(/%20/g, '+');
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
};

export const createMyAudiLink = ({ dealerId }: Partner): string => {
  const tenant = dealerId.substring(0, 2);
  const kvpsid = dealerId.substring(4, 9);
  return `https://my.audi.com/partner/details/${Buffer.from(
    `Partner:{"tenant":"${tenant}","kvpsid":"${kvpsid}"}`,
  ).toString('base64')}`;
};
